module.exports = __webpack_public_path__ + "static/media/hospitality.4bde2144.svg";